import React, { useRef, useState } from 'react';

import { iaRa } from 'lib/helpers/utility';

import { useClinicalNoteContext } from '../../../../../lib/context/ClinicalNoteContext/ClinicalNoteContext';
import { Allergies as initialValue } from '../CustomFormInitialStates';
import Container from '../components/Container';
import DeleteFormModal from '../components/DeleteFormModal';
import Header from '../components/Header';
import useCustomForm from '../lib/useCustomForm';
import useNewDesign from '../lib/useNewDesign';

import AllergiesRow from './AllergiesRow';

import '../Custom.scss';

const Allergies = ({
  forwardedRef,
  defaultValue,
  setCurrentFormData,
  formId = null,
  showNarrative = false,
  onChange,
  setAllergyModal = () => {}
}) => {
  const { cnDisplaySettings } = useClinicalNoteContext() || {};
  const [items, setItems] = useState(initialValue);

  const isAdvancedForm =
    cnDisplaySettings && showNarrative
      ? cnDisplaySettings?.sections?.hp?.allergies?.advancedForm
      : true;
  const textAreaRef = useRef();

  const [itemToDelete, setItemToDelete] = useState(null);

  const rows = 'allergies';

  const props = {
    itemToDelete,
    setItemToDelete,
    formId,
    setItems,
    setModal: setAllergyModal,
    items,
    rows,
    type: 'allergies',
    title: 'Allergies',
    alertTitle: 'Allergy',
    initialValue,
    textAreaRef,
    defaultValue,
    onChange,
    setCurrentFormData
  };

  const {
    handleAddRow,
    handleOnChange,
    handleNoDetails,
    onDelete,
    syncItems,
    length,
    validatedFields
  } = useCustomForm(props);

  const fromCheckin = location?.pathname.includes('/checkin');
  const newDesign = useNewDesign();

  return (
    <div className="Allergies CustomForms flex w-full flex-col items-center justify-center">
      <Header
        title="Allergies"
        noDetailsLabel="Do you have any known allergies?"
        isAdvancedForm={isAdvancedForm}
        noDetails={items?.noDetails}
        emptyState={
          fromCheckin && {
            title: 'No allergies reported yet',
            subtitle:
              'Allergies refer to reactions to medications, foods, or other substances. Please let us know if you have any to help us provide safer care.',
            label: 'Do you have any allergies not reported to our practice?'
          }
        }
        addRow={{
          onClick: handleAddRow,
          label: 'Do you want to add another allergy?',
          showButtonInCN: true
        }}
        handleNoDetails={handleNoDetails}>
        <div className="flex w-full flex-col items-center gap-y-4">
          {iaRa(items?.[rows])?.map((item, idx) => (
            <Container key={item.id} onDelete={() => onDelete(item?.id)} number={idx + 1}>
              <AllergiesRow
                key={item.id}
                index={idx}
                newDesign={newDesign}
                id={item?.id}
                onChange={handleOnChange}
                length={length}
                {...item}
              />
            </Container>
          ))}
        </div>
      </Header>

      <input type="hidden" value={JSON.stringify(validatedFields(items))} ref={forwardedRef} />

      <DeleteFormModal syncItems={syncItems} {...props} />
    </div>
  );
};

export default Allergies;
